export default{
    name: "Video",
    props: {
        id: {
            type: String
        },
        title: {
            type: String
        },
        width: {
            type: Number,
            default: 800
        },
        height: {
            type: Number,
            default: 450
        }
    },
    computed: {
        urlVideo(){
            return 'https://www.youtube.com/embed/' + this.id + '?controls=0';
        }
    }
}
